export const marker = 'selection_frontend_amazingScoring';

export const TYPE_LIST = {
    CONSUMER_CREDIT: 'CONSUMER_CREDIT',
    CREDIT_CARD: 'CREDIT_CARD',
    MORTGAGE: 'MORTGAGE',
    MICROLOAN: 'MICROLOAN',
} as const;

export const STATUS_LIST = {
    CREATED: 'CREATED',
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
} as const;

export const STRATEGY_LIST = {
    CC_GB_V1: 'person_gen7_cc_gb_v1',
    CL_GB_V1: 'person_gen7_cl_gb_v1',
} as const;
